import StarRating from '@alltrails/shared/denali/components/StarRating';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import { PhotoSize } from '@alltrails/shared/types/photos';
import type { Context } from 'types/Context';
import CustomProvider from 'components/CustomProvider';
import { TrailUgcProvider } from 'components/trailUgc/TrailUgcContext';
import PhotosUgc from 'components/trailUgc/PhotosUgc';
import ItemTotals from 'components/trailUgc/types/ItemTotals';
import { Photo } from 'types/Photo';
import Link from '@alltrails/shared/denali/components/Link';
import * as styles from './styles/styles.module.scss';

const DEFAULT_PHOTOS_PER_PAGE = 90;

export type PhotoPageProps = {
  context: Context;
  feedBaseUrl: string;
  hidePhotoUploadButton?: boolean;
  itemTotals: ItemTotals;
  locationServerData: { attribute: string; loc_id: number; type: string };
  photos: Photo[];
  rating: string | number;
  subtitle: string;
  subtitleLink: string;
  title: string;
};

const PhotoPage = ({
  context,
  feedBaseUrl,
  hidePhotoUploadButton = false,
  itemTotals,
  locationServerData,
  photos,
  rating,
  subtitle,
  subtitleLink,
  title
}: PhotoPageProps) => (
  <CustomProvider>
    <div className={styles.body}>
      <div className={styles.section}>
        <h1>{title}</h1>
        <h2>
          <Link href={subtitleLink} variant="secondary">
            {subtitle}
          </Link>
        </h2>
        <div className={styles.reviewsContainer}>
          <StarRating rating={Number(rating)} size="sm" />
          <span className={styles.reviews}>
            <FormattedMessage defaultMessage="{count,number} reviews" values={{ count: itemTotals.reviews }} />
          </span>
        </div>
        <TrailUgcProvider ugcInfo={{ photos, itemTotals }}>
          <PhotosUgc
            baseUrl={feedBaseUrl}
            dynamicPhotoSizes
            hideSortLabel
            locationServerData={locationServerData}
            trailId={locationServerData.type === 'trails' ? locationServerData.loc_id : undefined}
            perPage={DEFAULT_PHOTOS_PER_PAGE}
            photoSize={PhotoSize.Large}
            showContributeButton={!hidePhotoUploadButton}
            showInvitation={false}
            userId={context.currentUser?.id}
            context={context}
          />
        </TrailUgcProvider>
      </div>
    </div>
  </CustomProvider>
);

export default PhotoPage;
